import { Component, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

/**
 * Grip icon for reorderable Credit Proposal items. Use inside a `cdkDrag`
 * element with the `cdkDragHandle` directive on this host:
 *
 *   <app-section-drag-handle cdkDragHandle></app-section-drag-handle>
 */
@Component({
  selector: 'app-section-drag-handle',
  standalone: true,
  host: {
    class: 'section-drag-handle',
    role: 'img',
    '[attr.title]': 'label',
    '[attr.aria-label]': 'label',
  },
  template: `
    <svg class="h-4 w-4" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
      <path
        d="M7 4a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm0 6a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm-1.5 7.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM16 4a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm-1.5 7.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM16 16a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
      />
    </svg>
  `,
})
export class SectionDragHandle {
  private readonly translate = inject(TranslateService);

  get label(): string {
    return this.translate.instant('SECTION_BUILDER.DRAG_TO_REORDER');
  }
}
